<template>
  <LibraryLayout>
    <CustomListsBlock :view="view" />
  </LibraryLayout>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { CustomList } from '@/models/interfaces'
import { CustomListsView } from '@/models/custom.lists'
import { ListView } from '@/models/docs.list'

import LibraryLayout from '@/app/components/library/LibraryLayout.vue'
import CustomListsBlock from '../listing/CustomListsBlock.vue'

const props = defineProps<{
  lists: CustomList[]
}>()

const view = ref(createCustomListsListView())

function createCustomListsListView(): ListView {
  const docsView = new CustomListsView(props.lists)
  return new ListView('My Lists', docsView)
}
</script>
